<div>
  <div id="mainId" class="navigate">
    <img style="width: 250px;" src="assets/images/logo.png" />
    <div class="pull-right AppTitle">{{pahafYear}} Patient Annual Health Assessment</div>
  </div>

  <div class="body-content">
    <div class="panel panel-info formtitleSection">
      <div class="panelHeading formtitle">
        <span class="panel-title">{{formDataArray[0]?.lastName }},&nbsp;{{formDataArray[0]?.firstName}}</span>
      </div>
      <div class="panel-body" style="padding: 15px;">
        <div class="pull-left text-left">
          <div class="SmallTitle">{{parentValue.memberHmoID}}</div>
          <div>{{parentValue.memberDOB}},&nbsp;{{formDataArray[0]?.memberGender=='F'? 'FEMALE':'MALE'}}</div>
          <div>{{formDataArray[0]?.memberType}}</div>
        </div>
        <div class="pull-right text-right">
          <div class="SmallTitle">{{formDataArray[0]?.providerName}}</div>
          <div>{{formDataArray[0]?.providerNetwork}}</div>
          <div>{{formDataArray[0]?.pCPNeighborhood}}</div>
        </div>
      </div>
    </div>
    <div class="panel panel-info skyblue-border mb-4">
      <div class="panel-heading Instructions">
        <span>INSTRUCTIONS FOR CONDITION ASSESSMENT</span>
      </div>
      <div class="Instructionsbody">
        <span>
          <b>Please schedule a face-to-face Annual Wellness visit (AWV) with this patient. During the visit, assess each previously reported and potential
            condition presented on this form and record your response below using the legend. In addition to condition assessment, please refer to the open
            quality measure section to close gaps in care via documentation and claims submissions. If any section is blank, you should still submit the
          applicable medical record from the visit at the bottom of this form. Click "eSign" at the bottom of this form to ensure the submission is received by CareMore Health.</b>
        </span>
      </div>
      <div class="line"></div>
      <div class="InstructionsContent">
        <table>
          <tbody>
            <tr>
              <td width="2%"></td>

              <td width="3%">
                <img src="../../../../assets/images/icons/A.jpg" />
              </td>
              <td width="95%" style="font-size: 14px">
                Please check this box, if based on your assessment and independent clinical judgment, you <b>AGREE</b> the listed condition is currently active and present.
              </td>
            </tr>
            <tr>
              <td width="2%"></td>

              <td width="3%">
                <img src="../../../../assets/images/icons/D.jpg" />
              </td>
              <td width="95%" style="font-size: 14px">
                Please check this box, if based on your assessment and independent clinical judgment, you <b>DISAGREE</b> the listed condition is currently active and present. You should <u>not</u> document the reason you disagree in the progress note.
              </td>
            </tr>
            <tr>
              <td width="2%"></td>

              <td width="3%">
                <img src="../../../../assets/images/icons/U.jpg" />
              </td>
              <td width="95%" style="font-size: 14px">
                Please check this box, if based on your assessment and independent clinical judgment, you are <b>UNSURE</b> whether or not the condition is currently active and present.
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
      <div class="Instructionsbody1">
        <p>
          <p>This PAHAF should be completed during the patient's scheduled Annual Wellness Visit (AWV), where the claim is billed using an acceptable
            AWV code from the following: <b>G0402,G0438,G0439 or 99381-99397</b>. <br>
            If the conditions that are marked agree are not documented in the progress note, the patient may need to be brought back for another visit to
            have the condition(s) assessed during the <b>calendar year</b>. <br>
            Of note, please be sure to finalize your progress note and submit the medical record no later than <b>90 days</b> from date of service-including
            signature or electronic signature date. Please click "eSign" at the bottom of this form to ensure the submission is received by CareMore Health.<br>
            This form expires <b>12/31/2026</b> and must be submitted no later
            than <b>01/08/2027.</b>        </p>

          </div>
          <!-- <ng-container *ngIf="prevFlag"> -->
          <div class="panel panel-info mb-4 skyblue-border">
            <div class="panel-heading formtitle">
              <span class="panel-title LargeTitle">PREVIOUSLY REPORTED CONDITIONS</span>
            </div>
            <div class="panel-body" style="padding: 15px !important;">
              <div style="text-align: left">
                <p>Please document each diagnosis that is present in your assessment and support it with a plan in the progress note</p>
              </div>
              <table class="table table-hover table-bordered no-break">
                <thead style="background-color: #f5f5f5;">
                  <tr>
                    <th colspan="2">DIAGNOSIS</th>
                    <th>PCP REPORTED DATE</th>
                    <th>LAST REPORTED DATE</th>
                    <th>LAST PROVIDER</th>
                    <th class="ActionColumn">ASSESMENT</th>
                  </tr>
                </thead>
                @if (prevFlag == true) {
                  @for (i of uniquePrevCondition; track i; let rowIndex = $index) {
                    <tbody>
                      <tr>
                <td colspan="10" style="
                      font-size: 15px;
                      background-color: #ffffff;
                      font-weight: bold;
                    ">
                          {{ i.instruction }}
                        </td>
                      </tr>
                      <tr style="background-color: #ffffff">
                        <td>{{ i.dXCode }}</td>
                        <td>{{ i.dXDescription }}</td>
                        <td>{{ i.pcpreportedDate | date: 'MM/dd/yyyy' }}</td>
                        <td>{{ i.lastReportedDate | date: 'MM/dd/yyyy' }}</td>
                        <td>{{ i.lastProvider }}</td>
                        <td class="ActionColumn">
                          <!-- <div
                          dxcode="I11.0"
                          dxdesc="HYPERTENSIVE HEART DISEASE WITH HEART FAILURE"
                          hcc="85"
                          hccdescription="Congestive Heart Failure "
                          action=""
                          id="0289fb1d-99c2-4bf2-a557-139b64dd38b5"
                          memberid="502M97394~ProviderPortal"
                          ind="PRE"
                          suspectcondition=""
                          > -->
                          <!-- <input
                          type="checkbox"
                          value="0" name="DxCheckbox[1][]"
                          (click)="onlyOneDxCheckbox(this)"
                          class="DxCheckbox"
                          /> -->
                          <div class="my_class" (click)="clickEvent($event, i.dXCode)">
                            <label id="{{'A'+rowIndex}}" for="A_87" [ngClass]="test( i.dXCode, 'A'+rowIndex)"
                            class="DxCheckboxLabel A"></label>
                            <!-- <input
                            type="checkbox"
                            class="DxCheckbox"
                            value="1" name="DxCheckbox[1][]"
                            (click)="onlyOneDxCheckbox(this)"
                            /> -->
                            <label id="{{'D'+rowIndex}}" for="D_87" [ngClass]="test( i.dXCode, 'D'+rowIndex)"
                            class="DxCheckboxLabel D"></label>
                            <!-- <input
                            type="checkbox"
                            value="2" name="DxCheckbox[1][]"
                            (click)="onlyOneDxCheckbox(this)"
                            class="DxCheckbox"
                            /> -->
                            <label id="{{'U'+rowIndex}}" for="U_87" [ngClass]="test( i.dXCode, 'U'+rowIndex)"
                            class="DxCheckboxLabel U"></label>
                          <!-- </div> -->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                }
              }
            </table>
          </div>
        </div>
      <!-- </ng-container> -->
      <!-- <ng-container *ngIf="ptnFlag"> -->
      <div class="panel panel-info skyblue-border mb-4">
        <div class="panel-heading formtitle">
          <span class="panel-title LargeTitle">POTENTIAL CONDITIONS</span>
        </div>
        <div style="text-align: left; margin-top: 8px;margin-left: 15px">
          <p>Based on available clinical data, the patient may have one or more of the diagnosis listed below. Please assess what (if any) diagnosis the patient may have and for each diagnosis that is present, document in your assessment and support it with a plan in the progress note.</p>
        </div>

        @if (ptnFlag == true) {
          @for (k of resultDx; track k) {
            @for (j of k[1]; track j) {
              <div class="panel-body">
                <div class="panel panel-default">
                  <!-- <ng-container *ngFor="let j of i[1]"> -->
                  <div class="panel-body panel-body PotentialConditionHCC"></div>
                  <table class=" no-break table table-bordered table-condensed potentialTable">
                    <tbody>
                      <tr>
                        <td colspan=" 10" class=" PotentialConditionTitle">
                          {{j.dXCode}} - {{j.dXDescription}}
                        </td>
                        <td class="ActionColumn">
                          <!-- <div class="my_class" (click)="clickEvent($event, j.dXCode)"   -->
                          <div class="my_class" (click)="clickEvent($event, j.dXCode)">
                            <!-- <label id="{{'A'+rowIndex}}" for="A_87" [ngClass]="test( j.dXCode, 'A'+rowIndex)" class="DxCheckboxLabel A"></label>
                            <label id="{{'D'+rowIndex}}" for="D_87" [ngClass]="test( j.dXCode, 'D'+rowIndex)" class="DxCheckboxLabel D"></label>
                            <label  id="{{'U'+rowIndex}}" for="U_87" [ngClass]="test( j.dXCode, 'U'+rowIndex)" class="DxCheckboxLabel U"></label> -->
                            <label id="{{'A'+rowIndex}}" for="A_87" class="DxCheckboxLabel A"></label>
                            <label id="{{'D'+rowIndex}}" for="D_87" class="DxCheckboxLabel D"></label>
                            <label id="{{'U'+rowIndex}}" for="U_87" class="DxCheckboxLabel U"></label>
                          <!-- </div> -->
                        </div>
                      </td>
                    </tr>
                    <!-- <tr>
                    <td class="DxCodeColumn">{{ j.dXCode }}</td>
                    <td>{{ j.dXDescription }}</td>
                  </tr> -->
                </tbody>
              </table>
            <!-- </ng-container> -->
            <table class=" no-break table table-bordered table-condensed potentialTable">
              <thead>
                <tr>
                  <th class="DescIndicatorColumn">
                    INDICATION OF POTENTIAL CONDITION
                  </th>
                  <th class="ProvIndicatorColumn">PROVIDER</th>
                  <th class="DOSIndicatorColumn">DOS</th>
                </tr>
              </thead>
              <tbody>
                @for (val of k[1]; track val) {
                  <tr>
                    <td class="DescIndicatorColumn ">
                      {{ val.indicatorDescription }}
                    </td>
                    <td class="ProvIndicatorColumn">
                      {{ val.indicatorProvider }}
                    </td>
                    <td class="DOSIndicatorColumn ">
                      {{ val.indicatorDOS | date: 'MM/dd/yyyy' }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
    <!-- <ng-container *ngFor="let k of resultHcc"> -->
    @for (j of resultHcc; track j) {
      <div class="panel-body">
        <div class="panel panel-default">
          <!-- <ng-container *ngFor="let j of i[1]"> -->
          <div class="panel-body panel-body PotentialConditionHCC"></div>
          <table class=" no-break table table-bordered table-condensed potentialTable">
            <tbody>
              <tr>
                <td colspan=" 10" class=" PotentialConditionTitle">
                  {{j[0]}}
                </td>
                <td class="ActionColumn">
                  <!-- <div class="my_class" (click)="clickEvent($event, j.dXCode)"   -->
                  <div class="my_class" (click)="clickEvent($event, j.dXCode)">
                    <!-- <label id="{{'A'+rowIndex}}" for="A_87" [ngClass]="test( j.dXCode, 'A'+rowIndex)" class="DxCheckboxLabel A"></label>
                    <label id="{{'D'+rowIndex}}" for="D_87" [ngClass]="test( j.dXCode, 'D'+rowIndex)" class="DxCheckboxLabel D"></label>
                    <label  id="{{'U'+rowIndex}}" for="U_87" [ngClass]="test( j.dXCode, 'U'+rowIndex)" class="DxCheckboxLabel U"></label> -->
                    <label id="{{'A'+rowIndex}}" for="A_87" class="DxCheckboxLabel A"></label>
                    <label id="{{'D'+rowIndex}}" for="D_87" class="DxCheckboxLabel D"></label>
                    <label id="{{'U'+rowIndex}}" for="U_87" class="DxCheckboxLabel U"></label>
                  <!-- </div> -->
                </div>
              </td>
            </tr>
            <!-- <tr>
            <td class="DxCodeColumn">{{ j.dXCode }}</td>
            <td>{{ j.dXDescription }}</td>
          </tr> -->
        </tbody>
      </table>
    <!-- </ng-container> -->
    <table class=" no-break table table-bordered table-condensed potentialTable">
      <thead>
        <tr>
          <th class="DescIndicatorColumn">
            INDICATION OF POTENTIAL CONDITION
          </th>
          <th class="ProvIndicatorColumn">PROVIDER</th>
          <th class="DOSIndicatorColumn">DOS</th>
        </tr>
      </thead>
      <tbody>
        @for (val of j[1]; track val) {
          <tr>
            <td class="DescIndicatorColumn ">
              {{ val.indicatorDescription }}
            </td>
            <td class="ProvIndicatorColumn">
              {{ val.indicatorProvider }}
            </td>
            <td class="DOSIndicatorColumn ">
              {{ val.indicatorDOS | date: 'MM/dd/yyyy' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
}
<!-- </ng-container> -->
}
</div>

<div class="panel panel-info skyblue-border mb-4">
  <div class="panel-heading formtitle">
    <span class="panel-title LargeTitle">OPEN QUALITY MEASURES AS OF {{refreshDate}}</span>
  </div>
  <div style="text-align: left; margin-top: 8px;margin-left: 15px">
    Here is a list of open quality measures for your patient as of our most recent update.
    The instructions next to each quality gap indicate the action requested.
    Please refer to the quality coding guide for more information as needed.<br>
    <br>
    If you have medical records for A1C Control, Controlling Blood Pressure, or Colonoscopy, please upload to the Portal using the Quality Measure Document upload option, or email to  <u>businessperformance@caremore.com</u><br>
    <br>
  </div>
  <ng-container>
    <table class=" no-break table table-bordered table-condensed potentialTable">
      <thead>
        <tr>
          <th style="width:33%;">Measure</th>
          <th>Action Requested</th>
        </tr>
      </thead>
      <tbody>
        @for (measure of measuresListData; track measure) {
          <tr>
            <td>{{measure.measure}}</td>
            <td>{{measure.accompanyingMessage}}</td>
          </tr>
        }
      </tbody>
    </table>
  </ng-container>
</div>

<div class="panel panel-info skyblue-border mb-4">
  <div class="panel-heading formtitle">
    <span class="panel-title LargeTitle">QUALITY CODING GUIDE</span>
  </div>

  <div> &nbsp;&nbsp;&nbsp;</div>
  <div class="panel-body">
    <div class="col-12" style="display: flex; justify-content: center;">
      <ng-container>
        <table class="table table-hover table-bordered" style="width:60%">
          <thead style="display:none">
            <tr>
              <th style="width:50%"></th>
              <th style="width:30%"></th>
            </tr>
          </thead>
          @for (record of qualityHeaderList; track record) {
            <tbody>
              <tr>
                <td colspan="2" class="qualityRowHeader"><p>{{record.LOOKUP_CODE}}</p></td>
              </tr>
              @for (coding of getQualityCoding(record.LOOKUP_ID); track coding) {
                <tr>
                  <td>{{coding.LOOKUP_CODE}}</td>
                  <td>{{coding.LOOKUP_DESCRIPTION}}</td>
                </tr>
              }
            </tbody>
          }
        </table>
      </ng-container>
    </div>
  </div>


</div>

<!--<div class="panel panel-info skyblue-border mb-4">
<div class="panel-heading formtitle">
  <span class="panel-title LargeTitle">STARS/HEDIS MEASURES</span>
</div>
<ng-container >
  <div class="panel-body">
    <div class="panel panel-default  p-3">
      <div class="panel-body panel-body PotentialConditionHCC"></div>
      <table class=" no-break table table-bordered table-condensed potentialTable m-0">
        <tbody>
          <tr>
            <td class=" PotentialConditionTitle" style="text-align: center">
              PART C STAR MEASURES
            </td>
          </tr>
        </tbody>
      </table>

      <table class=" no-break table table-bordered table-condensed potentialTable">
        <thead>
          <tr>
            <th class="DescIndicatorColumn" style="text-align: center">
              Measure
            </th>
            <th class="ProvIndicatorColumn" style="text-align: center">HEDIS Specification</th>
            <th class="DOSIndicatorColumn" style="text-align: center">Value Set Codes</th>
          </tr>
        </thead>
        <tbody>
          <tr style="background-color: white">
            <td class="DescIndicatorColumn ">
              Breast Cancer Screening
            </td>
            <td class="ProvIndicatorColumn">
              Recommended for women age 50–74 to have a <br>
              mammogram in the 27 months prior to 12/31 of <br>
              the measurement year.
            </td>
            <td class="DOSIndicatorColumn ">
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>Exclusion: </strong></span> <br>
              <span style="color: black; font-weight: 200;font-size: medium;"><strong>- &nbsp;&nbsp;&nbsp;Z90.13</strong></span>- code if patient had two unilateral <br>
              mastectomies or a bilateral mastectomy
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Care for Older Adults – <br>
              Pain Assessment
            </td>
            <td>
              Recommended that adults 66 years and older <br>
              have at least one pain screening in the <br>
              measurement year. <br>
              •	&nbsp; Documentation should include a result of <br>
              pain assessment using a standardized <br>
              assessment tool.
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong> 1125F – </strong></span> severity quantified, Pain present<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>1126F – </strong></span> severity quantified, no pain <br>
              present
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Colorectal Cancer <br>Screening
            </td>
            <td>
              Recommended for patients age 50-75, who have <br>not had any of the following: <br>
              •	&nbsp;&nbsp;Colonoscopy in the current or 9 previous <br> calendar years <br>
              •	&nbsp;&nbsp;Flexible sigmoidoscopy in the current or 4 <br>previous calendar years <br>
              •	&nbsp;&nbsp;FOBT in the current calendar year <br>
              •	&nbsp;&nbsp;Cologuard (FIT-DNA) in the current or 2 <br> previous calendar years <br>
              •	&nbsp;&nbsp;CT colonography in the current or 4 previous<br> calendar years <br>
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>Exclusion: </strong></span> <br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong> -&nbsp;&nbsp;	Z85.038 – </strong></span> of malignant neoplasm of large intestine <br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong> -	&nbsp;&nbsp; Z85.048 – </strong></span> of other malignant <br>neoplasm of rectum, rectosigmoid <br> junction, and anus
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Controlling Blood <br>Pressure
            </td>
            <td>
              Members ages 18–75 with diabetes (types 1 <br>
              and 2) who have a blood pressure (BP) reading <br>
              of &lt;140/90 mmHg in the measurement year. <br>
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3078F - </strong></span> Diastolic &lt;80<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3079F - </strong></span> Diastolic 80-89<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3080F - </strong></span> Diastolic ≥ to 90<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3074F - </strong></span> Systolic &lt; 130<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3075F - </strong></span> Systolic 130-139<br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3077F - </strong></span> Systolic ≥ to 140<br>
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Eye Exam for Patients <br>With Diabetes
            </td>
            <td>
              Recommended for patients ages 18–75 with <br>
              diabetes (types 1 and 2) to have a dilated or <br>
              retinal eye exam in the measurement year.<br>
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>Exclusion: </strong></span> <br>
              -	&nbsp;&nbsp;<span style="color: black; font-weight: 200;font-size: medium;"> <strong>3072F – </strong></span>Negative retinal or dilated eye <br>
              exam (negative for retinopathy) by an eye <br>
              care professional in the year prior<br>
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Glycemic Status <br>Assessment for Patients <br>with Diabetes
            </td>
            <td>
              Members 18-75 years of age with diabetes <br>
              (types 1 and 2) whose most recent glycemic <br>
              status was &lt;9 in the measurement year.<br>
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3044F – </strong></span>HbA1c &lt; 7%
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3051F – </strong></span>HbA1c &gt; 7% and less than 8%
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3052F – </strong></span>HbA1c &gt; 8% and &lt; 9%
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>3046F – </strong></span>HbA1c &gt; 9%
            </td>
          </tr>
          <tr style="background-color: white">
            <td>
              Kidney Health Evaluation <br>for Patients with <br>Diabetes
            </td>
            <td>
              Recommended for patients 18–85 years of age <br>
              with diabetes (type 1 and type 2) to receive a <br>
              kidney health evaluation, defined by an <br>
              estimated glomerular filtration rate (eGFR) and <br>
              a urine albumin-creatinine ratio (uACR) in the <br>
              measurement year.<br>
            </td>
            <td>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>CPT: </strong></span> <br>
              <u>eGFR</u> – <span style="color: black; font-weight: 200;font-size: medium;"> <strong>80047, 80048, 80050, 80053, <br>
            80069, 82565</strong></span> <br>
            <u> Urine Creatinine Lab Test </u> – <span style="color: black; font-weight: 200;font-size: medium;"> <strong>82570 </strong></span> <br>
            <u> Quantitative Urine Albumin </u><br>
            <u>Lab Test </u>– <span style="color: black; font-weight: 200;font-size: medium;"> <strong>82043</strong></span> <br>
            <br>
              <span style="color: black; font-weight: 200;font-size: medium;"> <strong>LOINC: </strong></span> <br>
              Urine Albumin Creatinine Ratio <br>
              Lab Test - <span style="color: black; font-weight: 200;font-size: medium;"> <strong>13705-9, 14958-3, 14959-1, <br>
              30000-4, 44292-1, 59159-4, 76401-9, <br>
            77253-3, 77254-1, 89998-9, 9318-7 </strong></span> <br>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</div>
</ng-container>
</div>  -->
<!-- </ng-container> -->
<!-- <div id="starAndSign">
<form id="starAssesmentForm" name="starAssesmentForm">
  <div id="starAssesmentDiv" class="panel panel-default">
    <div class="panel-heading formtitle">
      <span>STAR ASSESSMENTS</span>
    </div>
    <div class="panel-body">
      <div style="text-align: center; font-size: 14px">
        Please complete the assessments below, document in progress note
        and sign/date the bottom of the form. Submit the appropriate
        Category II CPT code(s) along with your E/M service code when
        submitting your encounter.
      </div>
      <br />
      <div class="no-break panel-heading PotentialConditionTitle">
        <span>
          Care for Older Adult - Pain Assessment (Category II Codes:
          1125F, 1126F)
        </span>
      </div>
      <div class="no-break eachAssesmentStyle">
        1. On a scale of 0 to 10, with 0 being no pain and 10 being the
        worst pain, what is the patient's level? (choose one)
      </div>
      <div class="no-break eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_0" value="0" />
        0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_1" value="1" />
        1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_2" value="2" />
        2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_3" value="3" />
        3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_4" value="4" />
        4 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_5" value="5" />
        5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_6" value="6" />
        6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_7" value="7" />
        7 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_8" value="8" />
        8 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG1" id="radioG1_9" value="9" />
        9
      </div>
      <div class="no-break panel-heading PotentialConditionTitle">
        <span>
          Health Outcome Survey (HOS) - Monitoring Physical Activity
          (Category II Code: 1003F)
        </span>
      </div>
      <div class="no-break eachAssesmentStyle">
        2a. In the past 7 days, how many days did patient exercise?
        (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_0" value="0" />
        0 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_1" value="1" />
        1 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_2" value="2" />
        2 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_3" value="3" />
        3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_4" value="4" />
        4 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_5" value="5" />
        5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_6" value="6" />
        6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2a" id="radioG2a_7" value="7" />
        7
      </div>
      <div class="no-break  eachAssesmentStyle">
        2b. Did you advise the patient to start, increase, or maintain
        their physical activity? (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2b" id="radioG2b_1" value="0" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG2b" id="radioG2b_2" value="1" />
        NO
      </div>
      <div class=" no-break  panel-heading PotentialConditionTitle">

        HOS - Mental Health Assessment (Please submit any of these
        codes: G8431, G8510, G0444, G8511, or 96127)

      </div>
      <div class="no-break  eachAssesmentStyle">
        3a. Have physical or emotional problems interfered with the
        patient’s social activities (e.g., visiting with friends,
        relatives, etc.)? (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3a" id="radioG3a_all" value="All" />
        All of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3a" id="radioG3a_most" value="Most" />
        Most of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3a" id="radioG3a_some" value="Some" />
        Some of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3a" id="radioG3a_lil" value="Little" />
        A little of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3a" id="radioG3a_none" value="None" />
        None of the time
      </div>
      <div class="no-break  eachAssesmentStyle">
        3b. Over the last 2 weeks, how often has the patient been bothered
        by any of the following problems?
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; a. Little interest or
        pleasure in doing things (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b" id="radioG3b_not" value="Not" />
        Not at all &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b" id="radioG3b_sev" value="Sevaral" />
        Several days &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b" id="radioG3b_more" value="More" />
        More than half the days
        <input type="radio" name="radioG3b" id="radioG3b_nearly" value="Nearly" />
        Nearly every day
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; b. Feeling down, depressed,
        or hopeless (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b_b" id="radioG3b_b_All" value="All" />
        All of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b_b" id="radioG3b_b_most" [(ngModel)]="radio_Q2" value="Most" />
        Most of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b_b" id="radioG3b_b_some" [(ngModel)]="radio_Q3" value="Some" />
        Some of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b_b" id="radioG3b_b_little" [(ngModel)]="radio_Q4" value="little" />
        A little of the time &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3b_b" id="radioG3b_b_none" value="none" />
        None of the time
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;3c. If positive PHQ-9 or PHQ-2 findings, was patient
        offered counseling, medication or referred to behavioral health
        provider? (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3c" id="radioG3c_yes" value="yes" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3c" id="radioG3c_no" value="no" />
        NO &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG3c" id="radioG3c_na" value="Na" />
        NA
      </div>
      <div class="no-break panel-heading PotentialConditionTitle">
        HOS - Improving Bladder Control (Category II Codes: 1090F,
        0509F, 1091F)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;4a. Did the patient report urinary incontinence?
        (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG4a" id="radioG4a_yes" value="Yes" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG4a" id="radioG4a_no" value="No" />
        NO
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;4b. If yes, did you discuss treatment options like
        bladder training exercises, medication, and/or surgery? (choose
        one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG4b" id="radioG4b_yes" value="YES" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG4b" id="radioG4b_no" value="No" />
        NO
      </div>
      <div class="no-break panel-heading PotentialConditionTitle">
        HOS - Reducing the Risk of Falling (Category II Codes: 1100F,
        1101F, 3288F, 0518F)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;5a. In the past 12 months, did you perform a fall risk
        assessment? (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5a" id="radioG5a_yes" value="yes" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5a" id="radioG5a_no" value="No" />
        NO &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5a" id="radioG5a_na" value="Na" />
        NA
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;5b. For patients at risk of falling, did you refer
        them to Nifty after Fifty, physical therapy, order a Bone Density
        Test, or discuss other options? (choose one)
      </div>
      <div class="no-break  eachAssesmentStyle">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5b" id="radioG5b_yes" value="yes" />
        YES &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5b" id="radioG5b_no" value="no" />
        NO &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" name="radioG5b" id="radioG5b_na" value="na" />
        NA
      </div>
      <div class=" no-break panel-heading PotentialConditionTitle">
        Control of Blood Pressure (Category II Codes: 3074F, 3075F, 3079F, 3078F, 3077F, 3080F)
      </div>
      <div class="no-break  eachAssesmentStyle" style="color: #317eac">
        <span style="display: inline-block; width: 141px"></span>Systolic<span
      style="display: inline-block; width: 20px"></span>Diastolic
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;6a. Blood Pressure Value
      <input type="text" size="4" name="bpTextBox" id="bpTextBox1" [(ngModel)]="bpTextBox1" />
      /
      <input type="text" size="4" name="bpTextBox" id="bpTextBox2" [(ngModel)]="bpTextBox2" />
      mm/Hg (check systolic &amp; diastolic CPT-II box below if
      compliant; Note: Most recent BP reading/value counts towards
      measure)
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;6b.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox1" [(ngModel)]="bpCheckbox1" />
      Most recent systolic &lt; 130 (3074F)
      <span style="display: inline-block; width: 96px"></span> 6c.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox2" [(ngModel)]="bpCheckbox2" />
      Most recent diastolic &lt; 80 (3078F)
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;6d.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox3" [(ngModel)]="bpCheckbox3" />
      Most recent systolic 130-139 (3075F)
      <span style="display: inline-block; width: 80px"></span> 6e.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox4" [(ngModel)]="bpCheckbox4" />
      Most recent diastolic 80-89 (3079F)
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;6f.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox3" [(ngModel)]="bpCheckbox3" />
      Most recent systolic > 140(3077F)
      <span style="display: inline-block; width: 105px"></span> 6g.
      <input type="checkbox" name="bpcheckBoxGroup[]" id="bpCheckbox4" [(ngModel)]="bpCheckbox4" />
      Most recent diastolic > 90 (3080F)
    </div>
    <div class="panel-heading PotentialConditionTitle">
      Breast Cancer Screening (Display measure; Payment upon receipt
      of claim or encounter)
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;7. &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" value="1" name="myCheckbox[1][]" (click)="onlyOne(this)" />
      Completed &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[1][]" value="2" (click)="onlyOne(this) " />
      Referred &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[1][]" value="3" (click)="onlyOne(this) " />
      Refused &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[1][]" value="4" (click)="onlyOne(this) " />
      N/A &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[1][]" value="5" (click)="onlyOne(this) " />
      Bilateral/Unilateral Mastectomy
    </div>
    <div class="no-break panel-heading PotentialConditionTitle">
      Colorectal Cancer Screening (Display measure; Payment upon
      receipt of claim or encounter)
    </div>
    <div class="no-break  eachAssesmentStyle">
      &nbsp;&nbsp;8. &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[2][]" value="0" (click)="onlyOne(this) " />
      Completed &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[2][]" value="1" (click)="onlyOne(this) " />
      Referred &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[2][]" value="2" (click)="onlyOne(this) " />
      Refused &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[2][]" value="3" (click)="onlyOne(this) " />
      N/A &nbsp;&nbsp;&nbsp;&nbsp;
      <input type="checkbox" name="myCheckbox[2][]" value="4" (click)="onlyOne(this) " />
      Meets Exclusion Criteria
    </div>
    <div class="no-break  eachAssesmentStyle">
      <table>
        <tbody>
          <tr>
            <td width="4%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="chkbox" id="cb81" [(ngModel)]="cb81">
              </div>
            </td>
            <td width="24%">
              <div>Had colonoscopy in last 10 years.</div>
            </td>
            <td width="3%"></td>
            <td width="20%">
              <div>
                Date:
                <input type="date" ng-bind="date1 | date:'MM/dd/yyyy'" id="date1" [(ngModel)]="date1" />
              </div>
            </td>
            <td width="3%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb811" id="cb811" [(ngModel)]="cb811" />
              </div>
            </td>
            <td width="40%">
              <div>Colorectal cancer (code: G0213-5, G0231)</div>
            </td>
          </tr>
          <tr>
            <td width="4%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb82" id="cb82" [(ngModel)]="cb82" />
              </div>
            </td>
            <td width="24%">
              <div>Had flex sigmoidoscopy in last 5 years.</div>
            </td>
            <td width="3%"></td>
            <td width="20%">
              <div>
                Date:
                <input type="date" ng-bind="date2 | date:'MM/dd/yyyy'" id="date2" [(ngModel)]="date2" />
              </div>
            </td>
            <td width="3%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb821" id="cb821" [(ngModel)]="cb821" />
              </div>
            </td>
            <td width="40%">
              <div>
                Hx of neoplasm of large intestine (code: Z85.038)
              </div>
            </td>
          </tr>
          <tr>
            <td width="4%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb83" id="cb83" [(ngModel)]="cb83" />
              </div>
            </td>
            <td width="24%">
              <div>Had CT colonography in last 5 years.</div>
            </td>
            <td width="3%"></td>
            <td width="20%">
              <div>
                Date:
                <input type="date" ng-bind="date3 | date:'MM/dd/yyyy'" id="date3" [(ngModel)]="date3" />
              </div>
            </td>
            <td width="3%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb831" id="cb831" [(ngModel)]="cb831" />
              </div>
            </td>
            <td width="40%">
              <div>
                Hx of rectal, rectosigmoid, and anus neoplasm (Z85.048)
              </div>
            </td>
          </tr>
          <tr>
            <td width="4%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb84" id="cb84" [(ngModel)]="cb84" />
              </div>
            </td>
            <td width="24%">
              <div>Had Fit-DNA in last 3 years.</div>
            </td>
            <td width="3%"></td>
            <td width="20%">
              <div>
                Date:
                <input type="date" ng-bind="date4 | date:'MM/dd/yyyy'" id="date4" [(ngModel)]="date4" />
              </div>
            </td>
            <td width="3%"></td>
            <td width="3%">
              <div>
                <input type="checkbox" name="cb841" id="cb841" [(ngModel)]="cb841" />
              </div>
            </td>
            <td width="40%">
              <div>
                Total colectomy (code: 44150-3, 44155-8, 44210-2)
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="no-break  panel-heading PotentialConditionTitle">
      Diabetes Mellitus (Display measure only; Payment upon receipt of
      claim or encounter for eligible member/measure)
    </div>
    <div class="no-break  eachAssesmentStyle">
      <table>
        <tbody>
          <tr>
            <td width="2%"></td>
            <td width="18%">
              <div>9a. HbA1c control (&lt;/= 9%)</div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[3][]" value="Yes" (click)="onlyOne(this) " />
                &nbsp; Yes
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[3][]" value="No" (click)="onlyOne(this) " />
                &nbsp; No
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[3][]" value="Na" (click)="onlyOne(this) " />
                &nbsp; N/A
              </div>
            </td>
            <td width="2%"></td>
            <td width="51%">
              <div>
                *Note – most recent A1c test/value is what counts
                towards this control measure.
              </div>
            </td>
          </tr>
          <tr>
            <td width="2%"></td>
            <td width="18%">
              <div>9b. Kidney Evaluation (labs to complete eGRF and uACR)</div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[4][]" value="Yes" (click)="onlyOne(this) " />
                &nbsp; Yes
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[4][]" value="No" (click)="onlyOne(this) " />
                &nbsp; No
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[4][]" value="Na" (click)="onlyOne(this) " />
                &nbsp; N/A
              </div>
            </td>
            <td width="2%"></td>
            <td width="51%">
              <div>*Yes indicates completed or referred.</div>
            </td>
          </tr>
          <tr>
            <td width="2%"></td>
            <td width="18%">
              <div>9c. Retinal eye exam</div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[5][]" value="Yes" (click)="onlyOne(this) " />
                &nbsp; Yes
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[5][]" value="No" (click)="onlyOne(this) " />
                &nbsp; No
              </div>
            </td>
            <td width="2%"></td>
            <td width="7%">
              <div>
                <input type="checkbox" name="myCheckbox[5][]" value="Na" (click)="onlyOne(this) " />
                &nbsp; N/A
              </div>
            </td>
            <td width="2%"></td>
            <td width="51%">
              <div>*Yes indicates completed or referred.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <br />
    <div class="panel-heading PotentialConditionTitle" style="height: 54px;">
      <table>
        <tbody>
          <tr>
            <td width="40%" style="color: white">
              Provider Name:
                      <input style="
                          font-family: sans-serif;
                          color: black;
                          font-size: 16px;
                          width: 76%;
                        " type="text" />                      

              </td>
              <td width="3%"></td>
              <td width="30%" style="color: white">
                Submission Date:
                <input type="date" onfocus="(this.type='date')" onblur="if(!this.value)this.type='text'"
                  style="color: black" id="submissionDate" [(ngModel)]="submissionDate" />

                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <span class="sgnStyle">
          Signature
        </span>

        <div>

              <textarea _ngcontent-c6="" cols="50" rows="4" style="
    
    background-color: #f2f2f2;
    float: right;
"></textarea>
        </div>
        <br />
      </div>
    </div>
  </form>
</div> -->

<!-- <div ng-include="'/epahaf/app/functionality/hedisMeasures/hedisMeasuresView.html'">
<title></title>
<style>
  table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
text-align: left;
padding: 8px;
}

tr:nth-child(even) {
background-color: #f2f2f2;
}
</style>

<div class="panel-heading Instructions">
  <span>HEDIS MEASURES</span>
</div>
<div class="Hedisbody">
  <span style="display: inline-block; width: 30px"></span>
  <b>
    Please ensure your patient completes the HEDIS services listed
    below. This may not be the most recent data.
    <br /><span style="display: inline-block; width: 30px"></span>
    Please refer to the Provider Portal for the most up to date HEDIS
    information
  </b>
</div>
<div class="line"></div>
<br />

<div class="no-break  eachAssesmentStyle">
  <table>
    <tbody>
      <ng-container *ngFor="let each of memberMeasureDatas">
        <tr>

          <td>
            <span style="display: inline-block; width: 10px"></span>
          </td>
          <td>
            <h5>{{each.eventDesc}}</h5>
          </td>
        </tr>
      </ng-container>


    </tbody>
  </table>

</div>

<footer>
  <div class="progress" style="margin-bottom: 1px; height: 2px">
    <div class="progress-bar progress-bar-info" style="width: 100%"></div>
  </div>
  <div class="">
    <div class="pull-left">© 2017 CareMore</div>
    <div class="pull-right text-right" style="font-size: x-small">
      <br />
      Version: 1.1<br />
      CDDTSTWEBV001 | <span current-time="">5/25/21 12:47:22 AM</span>
    </div>
  </div>
</footer>
</div> -->
</div>